/**
 * This file works together with FrontPagePrefetchedDataProvider.server.tsx to prefetch data for the page during SSR.
 * Queries executed later in the component tree will retrieve the data from the Apollo cache.
 */
import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

const FrontPagePrefetchedDataProvider = ({ children }: Props) => {
  return <>{children}</>;
};

export default FrontPagePrefetchedDataProvider;
